// English-language first. TMDB's /trending is global, so a US arrival's first screen
// led with LINK CLICK, Black Clover and The Apothecary Diaries (2026-10-10). A stable
// partition keeps everything, just ordered so the shows most people here recognise
// come first; `only` drops the rest when at least `min` English rows remain (the
// onboarding grid has nine slots and no scroll, so there it is a filter).
// Pure and dependency-free so it runs under Node's test runner (see ship-gate notes).
export function preferEnglish(results, { only = false, min = 6 } = {}) {
  const list = Array.isArray(results) ? results : []
  const en = list.filter(s => s?.original_language === 'en')
  const rest = list.filter(s => s?.original_language !== 'en')
  if (only) return en.length >= min ? en : list
  return [...en, ...rest]
}
